import { forwardRef, Ref, type SVGProps } from 'react';

const SvgFoodForest = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <g fill="#033532" clipPath="url(#food-forest_svg__a)">
      <path d="M2.996 9.537s-7.654 7.318 3.845 9.488l-2.546-5.916.885-.335 2.242 5.91s5.916-9.648-4.424-9.147z" />
      <path d="m18.368 7.993.439-1.504-1.583-.384-1.432.494.384-.994 2.577-.935.747-1.031-1.17-.392-1.428.486.881-2.274-2.454.404-.509 1.327-.73-1.613-1.079-.602-.226 1.26 1.266 2.958-.405 1.047-.843-1.886-1.357-.913-.777 1.355 2.296 3.218-.389 1.012-1.308-2.233-1.705-.929-.458 3.097 1.564 1.78 1.16.23-2.167 5.643 2.171.198 1.951-5.036.615.439 2.344-.086 1.872-2.482-1.84-.608-2.123.502.437-1.127z" />
    </g>
    <defs>
      <clipPath id="food-forest_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgFoodForest);
export default ForwardRef;
